<template>
  <div class="galleryComp">
    <div v-if="!images || !images.length" class="div_nodata">
      <label for="" class="label_nodata">Нет фотографий</label>
    </div>
    <div class="div_gallery" v-if="images && images.length">
      <div v-for="(image, index) in images" :key="index" >
        <img v-img:group :src="`${$http.server_api_url}${image.url}`">
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'galleryComp',
  props: {
    images: Array
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.div_nodata {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-gap: 32px;
}
.div_gallery {
  margin: 32px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
}
.div_gallery > div {
  width: 100%;
  height: auto;
  min-height: 300px;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
  border-radius: 5px;
  border: 1px solid #202020;
}
.div_gallery > div > img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}
.div_gallery > div > img:hover {
  opacity: 0.5;
}

@media screen and (max-width: 1400px){
  .div_gallery{
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media screen and (max-width: 1140px){
  .div_gallery{
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 960px){
  .div_gallery{
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}
</style>
